import { createApp } from 'vue';
import M4aToOpusConverter from '@/Components/M4aToOpusConverter.vue';
import '@styles/app.css';

createApp(M4aToOpusConverter).mount('#m4a-to-opus-converter');
